import { bridgeConverter } from '../../bridge/bridgeConverter.tsx';
import { ExternalImportFileList } from '../../react/product/import/ExternalImportFileList.tsx';
import { FooBar } from '../../react/FooBar';
import { MetaFieldValues } from '../../react/MetaFieldValues';
import { MetaFields } from '../../react/MetaFields';
import { ColourChange } from '../../react/product/colourChange'
import { AssortmentPlanning } from '../../react/purchasing/assortmentPlanning'
import { BrandView } from '../../react/brands/BrandView'
import { CompanyView } from '../../react/companies/CompanyView'
import { UserView } from '../../react/users/UserView'
import { AccountView } from '../../react/accounts/AccountView'
import { CurrencyView } from '../../react/currencies/CurrencyView'
import { CustomerGroupView } from '../../react/customergroups/CustomerGroupView'
import { ArticleTypeView } from '../../react/articletypes/ArticleTypeView'
import { PaymentTypeView } from '../../react/paymenttypes/PaymentTypeView'
import { ReturnReasonView } from '../../react/returnreasons/ReturnReasonView'
import { ShippingMethodView } from '../../react/shippingmethods/ShippingMethodView'
import { PaymentTermView } from '../../react/paymentterms/PaymentTermView'
import { DeliveryTermView } from '../../react/deliveryterms/DeliveryTermView'
import { CountryView } from '../../react/countries/CountryView'
import { DepartmentView } from '../../react/departments/DepartmentView'
import { SubCategoryView } from '../../react/subcategories/SubCategoryView'
import { InvoiceTypeView } from '../../react/invoicetypes/InvoiceTypeView'
import { VatView } from '../../react/vats/VatView'
import { DeliveryPlanningTemplateView } from '../../react/deliveryplanningtemplates/DeliveryPlanningTemplateView'
import { OrderTypeView } from '../../react/ordertypes/OrderTypeView'
import { LocationView } from '../../react/locations/LocationView'
import { IntrastatView } from '../../react/intrastats/IntrastatView'
import { BusinessAreaView } from '../../react/businessareas/BusinessAreaView'
import { VolumeDiscountView } from '../../react/volumediscounts/VolumeDiscountView'
import { PsychologicalPriceView } from '../../react/psychologicalprices/PsychologicalPriceView'

angular
  .module('app.bridgeComponents', [])
  .component('fooBar', bridgeConverter(FooBar, ['hello']))
  .component('metaFieldValues', bridgeConverter(MetaFieldValues, ['values', 'initialIsEditing']))
  .component('metaFields', bridgeConverter(MetaFields, ['fields', 'initialIsEditing']))
  .component('colourChange', bridgeConverter(ColourChange, ['articleId']))
  .component('externalImportFileList', bridgeConverter(ExternalImportFileList, []))
  .component('assortmentPlanning', bridgeConverter(AssortmentPlanning, ['hi']))
  .component('brandView', bridgeConverter(BrandView, ['brandId']))
  .component('companyView', bridgeConverter(CompanyView, ['companyId']))
  .component('userView', bridgeConverter(UserView, ['userId']))
  .component('accountView', bridgeConverter(AccountView, ['accountId']))
  .component('currencyView', bridgeConverter(CurrencyView, ['currencyId']))
  .component('customerGroupView', bridgeConverter(CustomerGroupView, ['customerGroupId']))
  .component('articleTypeView', bridgeConverter(ArticleTypeView, ['articleTypeId']))
  .component('paymentTypeView', bridgeConverter(PaymentTypeView, ['paymentTypeId']))
  .component('returnReasonView', bridgeConverter(ReturnReasonView, ['returnReasonId']))
  .component('shippingMethodView', bridgeConverter(ShippingMethodView, ['shippingMethodId']))
  .component('paymentTermView', bridgeConverter(PaymentTermView, ['paymentTermId']))
  .component('deliveryTermView', bridgeConverter(DeliveryTermView, ['deliveryTermId']))
  .component('countryView', bridgeConverter(CountryView, ['countryId']))
  .component('departmentView', bridgeConverter(DepartmentView, ['departmentId']))
  .component('subCategoryView', bridgeConverter(SubCategoryView, ['subCategoryId']))
  .component('invoiceTypeView', bridgeConverter(InvoiceTypeView, ['invoiceTypeId']))
  .component('vatView', bridgeConverter(VatView, ['vatId']))
  .component('deliveryPlanningTemplateView', bridgeConverter(DeliveryPlanningTemplateView, ['deliveryPlanningTemplateId']))
  .component('orderTypeView', bridgeConverter(OrderTypeView, ['orderTypeId']))
  .component('locationView', bridgeConverter(LocationView, ['locationId', 'allowUpdate', 'isAllowedToSetAutoOrder']))
  .component('intrastatView', bridgeConverter(IntrastatView, ['intrastatId']))
  .component('businessAreaView', bridgeConverter(BusinessAreaView, ['businessAreaId']))
  .component('volumeDiscountView', bridgeConverter(VolumeDiscountView, ['volumeDiscountId']))
  .component('psychologicalPriceView', bridgeConverter(PsychologicalPriceView, ['psychologicalPriceId']));
